import { CartView } from "@/components/cart/cart-view";

export function CartPage() {
  return <CartView />;
}
